import { getBrandThemeColors } from '../../../shared/brandThemeColors';
import { defaultAmenitiesFilter } from '../../../shared/amenitiesFilter';
import {
  parseMaybeJson,
  normalizeBrandInfoJsonFields
} from '../../utils/brand-info-normalize';

function withNormalizedBrandInfo(brandPayload) {
  if (!brandPayload?.brand_info) return brandPayload;
  const normalizedInfo = normalizeBrandInfoJsonFields(brandPayload.brand_info);
  return {
    ...brandPayload,
    contact: parseMaybeJson(brandPayload.contact),
    brand_info: {
      ...normalizedInfo,
      colors: getBrandThemeColors(normalizedInfo)
    }
  };
}

export default function brandReducer(state={}, action){
  switch (action.type) {
    case "SET_BRAND": {
      const normalized = withNormalizedBrandInfo(action.brand);
      const brandWithInfo = {...normalized.brand, ...normalized};
      delete brandWithInfo['brand'];
      return {
        ...state,
        ...brandWithInfo,
        contact: normalized.contact,
        isRvFleet: brandWithInfo.organization.organization_type === 'rv_fleet',
        settings: {
          amenities_filter: defaultAmenitiesFilter(),
          ...(brandWithInfo.settings || {})
        }
      };
    }
    case "SET_HOME":
      return {...state, home: {...action.brand, options: action.brand.options}}
    default:
      return state;
  }
}